class FreeShippingMeter extends HTMLElement {
  constructor() {
    super();
  }

  // static freeShippingText = window.free_shipping_text.free_shipping_message; // Cart Vazio
  // static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;  // Frete Atingido
  // static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;  // Inicio frase 1
  // static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;  // Inicio frase 2
  static classLabel1 = "progress-30";
  static classLabel2 = "progress-60";
  static classLabel3 = "progress-100";
  static freeshipPrice = parseInt(window.free_shipping_price);

  connectedCallback() {
    this.strings = this.getGlobalStrings();
    this.freeShippingEligible = 0;
    this.progressBar = this.querySelector("[data-shipping-progress]");
    this.messageElement = this.querySelector("[data-shipping-message]");
    this.textEnabled = this.progressBar?.dataset.textEnabled === "true";
    this.shipVal = window.free_shipping_text.free_shipping_1;
    this.progressMeter = this.querySelector(
      "[ data-free-shipping-progress-meter]"
    );
    
    this.addEventListener("change", this.onCartChange.bind(this));

    this.initialize();
  }

  getGlobalStrings() {
    return {
      freeShippingTextLimit: window.limit_free_shipping_to_sp,
      freeShippingText: window.free_shipping_text_custom.free_shipping_message,
      freeShippingText1: window.free_shipping_text_custom.free_shipping_message_1,
      freeShippingText2: window.free_shipping_text_custom.free_shipping_message_2,
      freeShippingText3: window.free_shipping_text_custom.free_shipping_message_3,
    }
  }

  initialize() {
    Shopify.getCart((cart) => {
      this.cart = cart;
      this.calculateProgress(cart);
    });
  }

  onCartChange(e) {
    this.initialize();
  }

  calculateProgress(cart) {
    let totalPrice = cart.total_price;
    if ($("body").hasClass("setup_shipping_delivery")) {
      const giftCardItems = $(
        ".cart-item[data-price-gift-card], .previewCartItem[data-price-gift-card]"
      );
      if (giftCardItems.length > 0) {
        giftCardItems.each(function () {
          totalPrice -= parseFloat($(this).attr("data-price-gift-card"));
        });
      }
    }
    const cartTotalPrice = parseInt(totalPrice) / 100;
    const cartTotalPriceFormatted = cartTotalPrice.toFixed(2);
    const cartTotalPriceRounded = parseFloat(cartTotalPriceFormatted);

    let freeShipBar = Math.abs(
      (cartTotalPriceRounded * 100) / FreeShippingMeter.freeshipPrice
    );
    if (freeShipBar >= 100) {
      freeShipBar = 100;
    }

    const text = this.getText(cartTotalPriceFormatted, freeShipBar);
    let classLabel = this.getClassLabel(freeShipBar);

    if (this.strings.freeShippingTextLimit == true){
      classLabel = "progress-free";
      freeShipBar = 100;
    }

    this.setProgressWidthAndText(freeShipBar, text, classLabel);
  }

  getText(cartTotalPrice, freeShipBar) {
    let text;

    if (cartTotalPrice == 0) {
      this.progressBar.classList.add("progress-hidden");
      text =
        "<span>" +
        this.strings.freeShippingText +
        " " +
        Shopify.formatMoney(
          FreeShippingMeter.freeshipPrice * 100,
          window.money_format
        ) +
        "!</span>";
    } else if (cartTotalPrice >= FreeShippingMeter.freeshipPrice) {
      this.progressBar.classList.remove("progress-hidden");
      this.freeShippingEligible = 1;
      text = this.strings.freeShippingText1;
    } else {
      this.progressBar.classList.remove("progress-hidden");
      const remainingPrice = Math.abs(
        FreeShippingMeter.freeshipPrice - cartTotalPrice
      );
      text =
        "<span>" +
        this.strings.freeShippingText2 +
        " </span>" +
        Shopify.formatMoney(remainingPrice * 100, window.money_format) +
        '<span class="text">' +
        this.strings.freeShippingText3 +
        "</span>";
      this.shipVal = window.free_shipping_text.free_shipping_2;
    }

    if(this.strings.freeShippingTextLimit == true)
      return 'Frete grátis para a Grande São Paulo';
    return text;
  }

  getClassLabel(freeShipBar) {
    let classLabel;

    if (freeShipBar === 0) {
      classLabel = "none";
    } else if (freeShipBar <= 30) {
      classLabel = FreeShippingMeter.classLabel1;
    } else if (freeShipBar <= 60) {
      classLabel = FreeShippingMeter.classLabel2;
    } else if (freeShipBar < 100) {
      classLabel = FreeShippingMeter.classLabel3;
    } else {
      classLabel = "progress-free";
    }

    if(this.strings.freeShippingTextLimit == true)
      return "progress-free";
    return classLabel;
  }

  resetProgressClass(classLabel) {
    this.progressBar.classList.remove("progress-30");
    this.progressBar.classList.remove("progress-60");
    this.progressBar.classList.remove("progress-100");
    this.progressBar.classList.remove("progress-free");

    this.progressBar.classList.add(classLabel);
  }

  setProgressWidthAndText(freeShipBar, text, classLabel) {
    setTimeout(() => {
      this.resetProgressClass(classLabel);

      this.progressMeter.style.width = `${freeShipBar}%`;
      if (this.textEnabled) {
        const textWrapper = (this.progressMeter.querySelector(
          ".text"
        ).innerHTML = `${freeShipBar.toFixed(2)}%`);
      }

      this.messageElement.innerHTML = text;

      if ($(".dropdown-item[data-currency]").length) {
        if (
          (window.show_multiple_currencies &&
            typeof Currency != "undefined" &&
            Currency.currentCurrency != shopCurrency) ||
          window.show_auto_currency
        ) {
          Currency.convertAll(
            window.shop_currency,
            $("#currencies .active").attr("data-currency"),
            "span.money",
            "money_format"
          );
        }
      }
    }, 400);
  }
}

window.addEventListener("load", () => {
  customElements.define("free-shipping-component", FreeShippingMeter);
});
